// src/components/PageContainer.tsx
import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface PageContainerProps {
  subtitle?: string;
  children: React.ReactNode;
}

const PageContainer = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
  },
  // Let's make this more responsive
  maxWidth: '1200px',
  margin: '0 auto',
  '& > *': {
    width: '100%',
    textAlign: 'center', // Center all text content
    // Let's adjust max-width based on screen size
    [theme.breakpoints.down('sm')]: { // mobile
      maxWidth: '100%'
    },
    [theme.breakpoints.between('sm', 'md')]: { // tablet
      maxWidth: '600px'
    },
    [theme.breakpoints.up('md')]: { // desktop
      maxWidth: '800px'
    }
  }
}));

const PageContainerComponent: React.FC<PageContainerProps> = ({ subtitle, children }) => {
  return (
    <PageContainer>
      {subtitle && (
        <Typography 
          variant="h1" 
          sx={{ 
            mb: 2,
            width: '100%', // Ensure full width
            textAlign: 'center' // Ensure centered text
          }}
        >
          {subtitle}
        </Typography>
      )}

      {children}
    </PageContainer>
  );
};

export default PageContainerComponent;
